import React from 'react';

export type StoreState = any;
export type Dispatch = React.Dispatch<any>;

export const Store = React.createContext<
  { storeState: StoreState; dispatch: Dispatch } | undefined
>(undefined);
